// extracted by mini-css-extract-plugin
module.exports = {"product":"G_cv","product__image":"G_cw","product__featured":"G_cx","product__prices":"G_b4","product__prices__sale":"G_cy","product__title":"G_b0","product__title__sale":"G_cz"};